import { Auth } from 'aws-amplify';
export default {
  methods: {
    async logout() {
      this.$store.commit('spinner', true);
      try {
        Auth.signOut({
          global: true,
        });
      } finally {
        this.$store.commit('spinner', false);
        this.$router.push({
          name: 'login',
        });
      }
    },
  },
};
